import { render, staticRenderFns } from "./voluntariado-info.vue?vue&type=template&id=08f00bca"
import script from "./voluntariado-info.vue?vue&type=script&lang=js"
export * from "./voluntariado-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports